
import '@expo/match-media';
import { useMediaQuery } from 'react-responsive';
import React,{lazy, Suspense} from 'react';


function MyStack() {

const MyStackMobile = lazy(()=>import ('./authStack/authstackMobile'))
const MyStackDesktop = lazy(()=> import('./authStack/authstackDesktop'))


  const isTabletOrMobileDevice = useMediaQuery({ maxDeviceWidth: 600 });

 


  return( 
    <Suspense>
    {isTabletOrMobileDevice ? <MyStackMobile /> : <MyStackDesktop />}
    </Suspense>
    )
}
export default MyStack